import { useState } from 'react'
import { lumi } from '../lib/lumi'

interface UploadResult {
  fileName: string
  fileUrl?: string
  uploadError?: string
}

export function useFileUpload() {
  const [uploading, setUploading] = useState(false)
  const [uploadProgress, setUploadProgress] = useState(0)

  const uploadFiles = async (files: File[]): Promise<UploadResult[]> => {
    setUploading(true)
    setUploadProgress(0)

    try {
      const results = await lumi.tools.file.upload(files)
      console.log('Upload results:', results)
      setUploadProgress(100)
      return results
    } catch (error) {
      console.error('File upload failed:', error)
      throw error
    } finally {
      setUploading(false)
      setTimeout(() => setUploadProgress(0), 1000)
    }
  }

  const deleteFiles = async (fileUrls: string[]): Promise<void> => {
    try {
      await lumi.tools.file.delete(fileUrls)
      console.log('Files deleted:', fileUrls)
    } catch (error) {
      console.error('File delete failed:', error)
      throw error
    }
  }

  const uploadSingleFile = async (file: File): Promise<string> => {
    const results = await uploadFiles([file])
    const result = results[0]

    if (result.uploadError) {
      throw new Error(result.uploadError)
    }

    if (!result.fileUrl) {
      throw new Error('Upload failed: No file URL returned')
    }

    return result.fileUrl
  }

  return {
    uploading,
    uploadProgress,
    uploadFiles,
    uploadSingleFile,
    deleteFiles
  }
}
